import { useEffect, useState } from "react"
import { Subject, Syllabus } from "../../../../types/dataModel"
import useFetch from "../../../../hooks/useFetch"
import { API } from "../../../../common/Constants"
import PreLoader from "../../../../core/common/preLoader"
import { getAPIHeaders, isNotEmpty } from "../../../../common/Utils"
import { all_routes } from "../../../router/all_routes"
import FormFooter from "../../../../core/common/formFooter"
import CommonSelectV2 from "../../../../core/common/commonSelectV2"

interface Props {
    subject: Subject
    onSuccess: ()=> void
    readonly?:boolean
}

const ModifySubject = ({subject, onSuccess, readonly}:Props) => {
    const [formData, setFormData] = useState<Subject | undefined>(subject)
    const [syllabusList, setSyllabusList] = useState<Syllabus[]>([])
    const [selectedSyllabus, setSelectedSyllabus] = useState<any[]>([])

    const [msgBox, setMsgBox] = useState<any>({
      msg: "",
      error: false
    });
    const {isLoading, error, callFetch } = useFetch();

    useEffect(()=>{
      fetchSyllabus()
    },[])
    
    useEffect(()=>{
      setFormData(subject)
      if(subject?.syllabus){
        let syllabusCode:any = subject?.syllabus.map((ele)=> ele.code)
        if(syllabusCode?.length > 0){
          setSelectedSyllabus(syllabusCode)
        }
      } else {
        setSelectedSyllabus([])
      }

    },[subject])

    const reset = () => {
      resetMsgBox()
    }

    const resetMsgBox = () => {
      setMsgBox({
        msg: "",
        error: false
      })
    }

    const fetchSyllabus = () => {
        callFetch(API.SYLLABUS_SEARCH,
          'GET',
          getAPIHeaders(),
          null,
          null
      ).then(
        (res)=>setSyllabusList(res)
      );
    }
        
        
    useEffect(() => {
            if(error){
              if(error.response?.data){
                setMsgBox({msg: error.response?.data, error: true})
              } else{
                setMsgBox({msg: 'Something went wrong please try again later.', error: true})
              }
            }
    }, [error]);

    const handleSaveSubject = (event:any) => {
          event.preventDefault()
          if(!formData?.title){
            setMsgBox({msg: "Please provide title", error: true})
          } else if(!formData?.description){
            setMsgBox({msg: "Please provide description", error: true})
          } else if(!formData?.code){
            setMsgBox({msg: "Please provide code", error: true})
          } else {
            setMsgBox({msg:"",error: false})
            callFetch(API.SUBJECT,
                  'PUT',
                  getAPIHeaders(),
                  null,
                  {
                     ...formData
                  }
              ).then(()=>{
                setMsgBox({msg: "Updated successfully", error: false})
                onSuccess()
              });
          }
    }

    const handleSaveSyllabus = (event:any) => {
      event.preventDefault()
      if(!selectedSyllabus || selectedSyllabus.length === 0){
        setMsgBox({msg: "Please select syllabus", error: true})
      } else if(!isNotEmpty(formData?.code)){
        setMsgBox({msg: "Please provide subject code", error: true})
      }  else {
        setMsgBox({msg:"",error: false})
        callFetch(API.SUBJECT_SYLLABUS,
              'POST',
              getAPIHeaders(),
              null,
              {
                subjectCode: formData?.code,
                syllabusCodes: selectedSyllabus
              }
          ).then(()=>{
            setMsgBox({msg: "Updated successfully", error: false})
            onSuccess()
          }).catch((err)=>{
            setMsgBox({msg: 'Failed to update syllabus. Please try again.', error: true});
          });
      }
}

    const renderBasicInfoFrom = () => {
      return (
        <div
        className="tab-pane fade show active" 
        id="basic-info2"
        role="tabpanel"
        aria-labelledby="info-tab2"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Title <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control" 
                    disabled={readonly}
                    value={formData?.title}
                    onChange={(e)=>{
                      setFormData({
                        ...formData,
                        title: e.target.value
                      })
                    }}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Description <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control"
                    disabled={readonly}
                        value={formData?.description}
                        onChange={(e)=>{
                            setFormData({
                                ...formData,
                                description: e.target.value
                            })
                        }} />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Code <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control"
                        value={formData?.code}
                        onChange={(e)=>{
                          setFormData({
                                ...formData,
                                code: e.target.value
                            })
                        }} disabled/>
                  </div>
                </div>
          </div>
        </div>
        <div className="modal-footer">
              <FormFooter
                readonly={readonly}
                onCancel={reset}
                onSave={handleSaveSubject}
                error={msgBox.error}
                message={msgBox.msg} 
              />
            </div>
      </div> 
      )
    }

    const renderSyllabusInfoFrom = () => {
      return (
        <div
        className="tab-pane fade show"
        id="syllinfo"
        role="tabpanel"
        aria-labelledby="syll-infotab"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Syllabus <span className="text-danger"> *</span></label>
                    <CommonSelectV2
                      isMulti
                      className='select'
                      options={parseSyllabusToOptions(syllabusList)}
                      values={parseSyllabusToOptions(syllabusList).filter(
                        (option) => selectedSyllabus.includes(option.value)
                      )}
                      onChange={(value) => {
                        setSelectedSyllabus(value)
                      }}
                      disabled={readonly}
                      formatOptionLabel={(option: any) => (
                        <div>
                          <h6 className="d-flex align-items-center">
                            {option.label}
                            <span className={`ms-2 badge badge-primary rounded-pill`}>
                              {option.value}
                            </span>
                          </h6>
                        </div>
                      )}
                    />
                  </div>
                </div>
          </div>
        </div>
        <div className="modal-footer">
              <FormFooter
                  onCancel={reset}
                  onSave={handleSaveSyllabus}
                  error={msgBox.error}
                  message={msgBox.msg} 
                  readonly={readonly}
                />
        </div>
      </div> 
      )
    }
    
    return (
      <div className="modal fade" id="edit_subject"
      data-bs-backdrop="static"
      data-bs-keyboard="false">
       <PreLoader showLoader={isLoading} />
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h4 className="modal-title me-2">Edit Subject</h4>
            </div>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={reset}
            >
              <i className="ti ti-x" />
            </button>
          </div>


          <form action={all_routes.subjects}>
            <div className="contact-grids-tab">
              <ul className="nav nav-underline" id="myTab2" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="info-tab2"
                    data-bs-toggle="tab"
                    data-bs-target="#basic-info2"
                    type="button"
                    role="tab"
                    aria-selected="true"
                    onClick={resetMsgBox}
                  >
                    Basic Information
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="syll-infotab"
                        data-bs-toggle="tab"
                        data-bs-target="#syllinfo"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        onClick={resetMsgBox}
                      >
                        Syllabus Info
                      </button>
                </li>
              </ul>
            </div>
            <div className="tab-content" id="myTabContent2">  
                {renderBasicInfoFrom()}
                {renderSyllabusInfoFrom()}
            </div>
          </form>


        </div>
      </div>
    </div>
    )
}

function parseSyllabusToOptions (data: Syllabus[]) {
  let opts: any[] = []
  if(data){
    data.forEach((ele)=> opts.push({
      value: ele.code,
      label: ele.title
    }))
  }
  return opts;
}

export default ModifySubject